var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentPriceName,{tag:"component",attrs:{"price":_vm.price,"currency":_vm.currency,"promotions":_vm.promotions,"show-header":_vm.showHeader,"show-footer":_vm.showFooter,"parent-data":_vm.parentData,"product":_vm.product,"with-exchange-rate":_vm.withExchangeRate}})
}
var staticRenderFns = []

export { render, staticRenderFns }